import { render, staticRenderFns } from "./FavElement.vue?vue&type=template&id=e9ee55de&"
import script from "./FavElement.vue?vue&type=script&lang=js&"
export * from "./FavElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e9ee55de')) {
      api.createRecord('e9ee55de', component.options)
    } else {
      api.reload('e9ee55de', component.options)
    }
    module.hot.accept("./FavElement.vue?vue&type=template&id=e9ee55de&", function () {
      api.rerender('e9ee55de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8nBPJ0poyi4xR/JS/comp/FavElement.vue"
export default component.exports